import React, { useEffect } from "react";
import { Controls } from "../controls/controls";
import { Messages } from "../Messages/Messages";
import Loader from "../loader/loader";
import { useState } from "react";
import styles from "./Chat.module.css";

export const Chat = ({ assistant, chatId, chatMessages, onChatMessagesUpdate, isActive = false}) => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setisLoading] = useState(false);


  useEffect(() => {
  async function initChat() {
    setMessages(chatMessages);

    if (assistant?.name === "googleai") {
      try {
        await assistant.createChat(chatMessages);
        console.log("Chat created");
      } catch (err) {
        console.error("Failed to create chat", err);
      }
    }
  }

  initChat();
}, [chatId]);



  useEffect(()=>{
    onChatMessagesUpdate(chatId, messages)
  }, [messages])

  function addMessage(message) {
    setMessages((prevMessages) => [...prevMessages, message]);
  }

  async function handlecontentsend(content) {
    addMessage({ content, role: "user" });
    setisLoading(true);
    try {
      const result = await assistant.chat(content);
      addMessage({ content: result, role: "assistant" });
    } catch (error) {
      console.error("Gemini API error:", error);
      addMessage({
        content: "Oops! Something went wrong. Please try again.",
        role: "system",
      });
    } finally {
      setisLoading(false);
    }
  }
  if(!isActive) return null;
  return (
    <>
      {isLoading && <Loader />}

      <div className={styles.chat}>
        <Messages messages={messages} />
      </div>
      <Controls onSend={handlecontentsend} isDisabled={isLoading} />
    </>
  );
};
